import { render, staticRenderFns } from "./InspectionCriteria5.vue?vue&type=template&id=3da9a2b6&scoped=true"
import script from "./InspectionCriteria5.vue?vue&type=script&lang=ts"
export * from "./InspectionCriteria5.vue?vue&type=script&lang=ts"
import style0 from "./InspectionCriteria5.vue?vue&type=style&index=0&id=3da9a2b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da9a2b6",
  null
  
)

export default component.exports